import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import Navbar from "./pages/navbar";
import GraphGif from "./pages/graphGif";
import RatePage from "./pages/ratePage";
import MarketSection from "./pages/MarketSection";
import AboutPage from "./pages/AboutPage";
import Footer from "./pages/Footer";
import BuyCryptoPage from "./pages/BuyCryptoPage";
import NewsPage from "./pages/newsPage";
import CryptoBlog from "./pages/CryptoNestBlog";

/* 🔹 This component is INSIDE the router */
function AppContent() {
  const location = useLocation();

  useEffect(() => {
    const sections = document.querySelectorAll(".section");
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [location.pathname]); // ✅ FIX

  return (
    <>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <div className="section"><GraphGif /></div>
              <div className="section"><RatePage /></div>
              <div className="section"><MarketSection /></div>
              <div className="section"><AboutPage /></div>
            </>
          }
        />

        <Route path="/buy-crypto" element={<BuyCryptoPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/blog" element={<CryptoBlog />} />
      </Routes>

      <Footer />
    </>
  );
}

/* 🔹 Router lives here */
export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
